import type { PlateContentProps } from "platejs/react";
import { PlateContainer, PlateContent } from "platejs/react";
import type * as React from "react";
import { cn } from "@/lib/utils";

export function EditorContainer({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<PlateContainer
			className={cn(
				"ignore-click-outside/toolbar relative h-full w-full cursor-text select-text overflow-y-auto caret-primary selection:bg-primary/25 focus-visible:outline-none",
				className,
			)}
			{...props}
		/>
	);
}

export type EditorProps = PlateContentProps;

export function Editor({
	className,
	ref,
	...props
}: EditorProps & { ref?: React.RefObject<HTMLDivElement | null> }) {
	return (
		<PlateContent
			ref={ref}
			className={cn(
				"group/editor",
				"relative w-full cursor-text select-text overflow-x-hidden whitespace-pre-wrap break-words",
				"rounded-md ring-offset-background focus-visible:outline-none",
				"**:data-slate-placeholder:!top-1/2 **:data-slate-placeholder:-translate-y-1/2 placeholder:text-muted-foreground/80 **:data-slate-placeholder:text-muted-foreground/80 **:data-slate-placeholder:opacity-100!",
				"[&_strong]:font-bold",
				"size-full px-8 pt-4 pb-32 text-base",
				className,
			)}
			disableDefaultStyles
			{...props}
		/>
	);
}
